<template>
    <span>
        <b-button
            class="mr-2"
            variant="success"
            @click.stop="abrirModal()"
        >
            <i class="fa fa-file-text-o mr-2"></i>Aprovar Documentos
        </b-button>

        <b-modal
            v-model="mostrarModal"
            size="xl"
            no-close-on-backdrop
            @hidden="fecharModal()"
        >
            <div slot="modal-title">Aprovar Documentos do Boletim de Medição</div>

            <p class="text-muted">
                Revise os documentos anexados pelo fornecedor. Se estiver tudo correto, aprove os documentos para
                liberar o envio da Nota Fiscal. Caso contrário, devolva o Boletim de Medição para correção.
            </p>

            <boletim-medicao-anexos
                :contrato="contrato"
                :boletimMedicao="boletimMedicao"
                :anexosMedicao="boletimMedicao.anexos"
                :editavel="false"
                :mostrarFiltro="false"
            />

            <div slot="modal-footer">
                <b-button variant="secondary" class="mr-2" @click.stop="fecharModal()">Fechar</b-button>
                <b-button variant="warning" class="mr-2" @click.stop="abrirModalDevolver()">
                    <i class="fa fa-undo mr-2"></i>Devolver para Correção
                </b-button>
                <b-button variant="success" @click.stop="confirmarAprovacao()">
                    <i class="fa fa-check mr-2"></i>Aprovar Documentos
                </b-button>
            </div>
        </b-modal>

        <b-modal
            v-model="mostrarModalDevolver"
            size="md"
            no-close-on-backdrop
            @hidden="fecharModalDevolver()"
        >
            <div slot="modal-title">Devolver Boletim de Medição para Correção</div>

            <b-form-group>
                <label class="required">Justificativa:</label>
                <b-form-textarea
                    v-model="justificativa"
                    rows="4"
                    max-rows="8"
                    :no-resize="true"
                    placeholder="Descreva o que precisa ser corrigido pelo fornecedor"
                ></b-form-textarea>
            </b-form-group>

            <div slot="modal-footer">
                <b-button variant="secondary" class="mr-2" @click.stop="fecharModalDevolver()">Cancelar</b-button>
                <b-button variant="warning" :disabled="!justificativa" @click.stop="confirmarDevolucao()">
                    Devolver para Correção
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>

import BoletimMedicaoAnexos from './abasMedicao/BoletimMedicaoAnexos.vue';
import { etapaBoletimMedicaoEnum } from '../BoletimMedicao.js';

export default {
    components: {
        BoletimMedicaoAnexos,
    },

    props: {
        contrato: {
            type: Object,
            default: null,
        },
        boletimMedicao: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            mostrarModal: false,
            mostrarModalDevolver: false,
            justificativa: null,
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        abrirModalDevolver() {
            this.justificativa = null
            this.mostrarModalDevolver = true
        },

        fecharModalDevolver() {
            this.mostrarModalDevolver = false
        },

        confirmarAprovacao() {
            this.$swal({
                title: 'Atenção',
                html: 'Deseja realmente aprovar os documentos deste Boletim de Medição e liberar o envio da Nota Fiscal?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.emitirConclusaoEtapa(etapaBoletimMedicaoEnum.AprovacaoParaEnvioNotaFiscal, null)
                    this.fecharModal()
                }
            })
        },

        confirmarDevolucao() {
            if (!this.justificativa) return

            this.emitirConclusaoEtapa(etapaBoletimMedicaoEnum.DevolucaoParaReassinarFornecedor, this.justificativa)
            this.fecharModalDevolver()
            this.fecharModal()
        },

        emitirConclusaoEtapa(etapa, observacao) {
            this.$emit('concluirEtapa', {
                etapa,
                observacao,
                anexos: [],
                itensAprovados: [],
            })
        },
    },
}
</script>
